
import BrandPage from '../AdminPages/Brands'

function DevBrands() {
  return (
    <BrandPage/>
  )
}

export default DevBrands